// 取得點數餘額
export class GetCoinBalance {
  static readonly type = '[VenderUser] GetCoinBalance';
}

// 取得點數交易紀錄
export class GetCoinTxn {
  static readonly type = '[VenderUser] GetCoinTxn';
}
